module.exports = __webpack_public_path__ + "static/media/visa.02a3d5de.svg";